import { Bell, Plus } from 'lucide-react'
import { Button } from '@/components/ui/button'
import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from '@/components/ui/empty'

type Props = {
  canCreate: boolean
  onCreate: () => void
}

export const UsageAlertEmptyState = ({ canCreate, onCreate }: Props) => (
  <Empty className="border-0 p-2 md:p-6">
    <EmptyHeader>
      <EmptyMedia variant="icon">
        <Bell />
      </EmptyMedia>
      <EmptyTitle>No usage alert configured</EmptyTitle>
      <EmptyDescription>
        Set a budget and get notified by email when spending crosses the
        thresholds you choose.
      </EmptyDescription>
    </EmptyHeader>
    {canCreate && (
      <EmptyContent>
        <Button onClick={onCreate}>
          <Plus />
          Add alert
        </Button>
      </EmptyContent>
    )}
  </Empty>
)
